<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>计划管理</el-breadcrumb-item>
			<el-breadcrumb-item>产品管理</el-breadcrumb-item>
		</el-breadcrumb>
		<!--搜索部分-->
		<div class="form-bar">
			<el-row>
				<el-col :span="16">
					<el-form :inline="true">
						<el-form-item label="产品搜索">
							<el-input v-model="queryKey" placeholder="按名称进行产品搜索" maxlength="150">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="info" @click="query">查询</el-button>
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="8" style="text-align:right;">
					<el-button type="primary" @click="add">新增产品</el-button>
					<el-button type="primary" @click="$router.push({ name: 'productImport' })">通过Excel导入</el-button>
				</el-col>
			</el-row>
		</div>
		<!--表格部分-->
		<div class="tableList">
			<el-table border v-loading="loading" :data="tableData" v-on:sort-change="sortChange" v-on:filter-change="filterChange">
				<el-table-column type="index" label="序号" width="50"></el-table-column>
				<el-table-column label="产品名称">
					<template slot-scope="scope">
						<span v-text="scope.row.name"></span>
						<el-popover placement="top" title="备注" width="200" trigger="click" :content="scope.row.remark">
							<a href="javascript:;" style="color:#aaa;" slot="reference" v-show="scope.row.remark">
								<i class="el-icon-s-opportunity"></i>
							</a>
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column prop="code" label="编号" width="120"></el-table-column>
				<el-table-column prop="grade" label="产品等级" width="120">
					<template slot-scope="scope">
						<span v-text="getLevelName(scope.row.grade)"></span>
					</template>
				</el-table-column>
				<el-table-column label="工艺组" width="200">
					<template slot-scope="scope">
						<el-popover placement="right" width="450" trigger="click">
							<TechDetails :groupId="currentTechGroupId" v-if="scope.row.tech_group_id == currentTechGroupId" />
							<el-link style="margin-right:20px;" slot="reference" @click="showTeachGroupDetailDialog(scope.row)" v-text="formatTeachGroupName(scope.row.tech_group_id)"></el-link>
						</el-popover>
						<span></span>
					</template>
				</el-table-column>
				<el-table-column label="工序组" width="200">
					<template slot-scope="scope">
						<el-popover placement="right" width="450" trigger="click">
							<ProcessDetails :groupId="currentProcessGroupId" v-if="scope.row.process_group_id == currentProcessGroupId" />
							<el-link style="margin-right:20px;" slot="reference" v-show="scope.row.process_group_id" @click="showProcessDetails(scope.row)" v-text="formatProcessGroupName(scope.row.process_group_id)"></el-link>
						</el-popover>
						<span></span>
					</template>
				</el-table-column>
				<el-table-column prop="created_time" sortable="custom" label="创建日期" width="180">
					<template slot-scope="scope">
						<span v-text="formatDate(scope.row.created_time)"></span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="300">
					<template slot-scope="scope">
						<el-button @click="handleEdit(scope.row)" type="text">修改</el-button>
						<el-divider direction="vertical"></el-divider>
						<el-button type="text" size="min" @click="showTeachGroupDialog(scope.row)">设置工艺组</el-button>
						<el-divider direction="vertical"></el-divider>
						<el-button type="text" size="min" @click="showProcessGroupDialog(scope.row)">设置工序组</el-button>
						<el-divider direction="vertical"></el-divider>
						<el-popconfirm title="确定删除吗？" @onConfirm="handleDelete(scope.row)">
							<el-button type="text" slot="reference">删除</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<!--分页-->
			<el-pagination layout="sizes, prev, pager, next, total" :page-count="pageCount" :page-sizes="[10, 50, 100, 200]" :size="pageSize" @current-change="currentChange" @size-change="sizeChange"></el-pagination>
		</div>

		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
			<el-form ref="productForm" label-position="top" :model="form" :rules="rules">
				<el-form-item label="产品名称" prop="name">
					<el-input v-model.trim="form.name" maxlength="150" show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="产品编号" prop="code">
					<el-input v-model.trim="form.code" maxlength="50"></el-input>
				</el-form-item>
				<el-form-item label="产品等级" prop="grade">
					<el-select v-model="form.grade" placeholder="请选择">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="备注">
					<el-input type="textarea" v-model.trim="form.remark" maxlength="200"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="save('productForm')" :loading="saving">保存</el-button>
			</span>
		</el-dialog>

		<!--工序组设置-->
		<el-dialog :title="dialog.process.title" :visible.sync="dialog.process.visible" width="800px">
			<ProcessGroup v-on:select="handleSelectGroup" />
		</el-dialog>

		<!--工艺组设置-->
		<el-dialog :title="dialog.tech.title" :visible.sync="dialog.tech.visible" width="800px">
			<TechGroup v-on:select="setTeachGroup" />
		</el-dialog>
	</div>
</template>

<script>
	import { productRequest, queryProduct, setProductTechGroup, saveProduct } from '@/network/requests/product'
	import moment from 'moment'
	import NProgress from 'nprogress'
	import { ProductLevel } from '@/components/Product'
	import { techGroupRequest } from '@/network/requests/techGroup'
	import { processGroupRequest } from '@/network/requests/processGroup'
	import ProcessGroup from '@/components/ProcessGroup'
	import ProcessDetails from '@/components/ProcessDetails'
	import TechGroup from '@/components/TechGroup'
	import TechDetails from '@/components/TechDetails'
	export default {
		components: {
			ProcessGroup,
			ProcessDetails,
			TechGroup,
			TechDetails,
		},
		data() {
			this.options = ProductLevel.data
			return {
				tableData: [],
				currentProductId: '',
				pageSize: 10,
				pageIndex: 1,
				queryKey: '',
				loading: false,
				saving: false,
				pageCount: 1,
				createdTimeSort: -1,
				filterUpdated: [0, 1],
				dialogVisible: false,
				dialogTitle: '',
				form: {},
				rules: {
					name: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
					code: [{ required: true, message: '请输入产品编号', trigger: 'blur' }],
					grade: [{ required: true, message: '请输选择等级', trigger: 'blur' }],
				},
				dialog: {
					process: {
						title: '设置工序',
						visible: false,
					},
					tech: {
						title: '设置工艺参数组',
						visible: false,
					},
				},
				techGroups: [],
				processGroups: [],
				currentTechGroupId: '',
				currentProcessGroupId: '',
			}
		},
		computed: {},
		watch: {
			createdTimeSort(val) {
				this.query()
			},
		},
		methods: {
			/**
			 * 弹出工艺参数组设置。
			 */
			showTeachGroupDialog(row) {
				this.currentProductId = row._id.$oid
				this.dialog.tech.visible = true
			},
			/**
			 * 显示工艺参数详情。
			 */
			showTeachGroupDetailDialog(row) {
				this.currentProductId = row._id.$oid
				this.currentTechGroupId = row.tech_group_id
			},
			/**
			 * 设置工艺参数组。
			 */
			setTeachGroup(teachGroupInfo) {
				setProductTechGroup(this.currentProductId, teachGroupInfo.id, teachGroupInfo.name)
					.then(res => {
						console.log('set product tech group', res)
					})
					.finally(() => {
						this.dialog.tech.visible = false
						//重新加载产品列表。
						this.query()
					})
			},
			/**
			 * 格式化工艺参数组名称。
			 */
			formatTeachGroupName(id) {
				var p = this.techGroups.find(t => t._id.$oid == id)
				if (p) {
					return p.name
				}

				return ''
			},

			/**
			 * 格式化工序名称。
			 */
			formatProcessGroupName(id) {
				var p = this.processGroups.find(t => t._id.$oid == id)
				if (p) {
					return p.name
				}

				return ''
			},

			/**
			 * 格式化日期。
			 */
			formatDate(date) {
				if (date) return moment(date.$date).format('YYYY-MM-DD HH:mm:ss')
			},
			/**
			 * 查询产品。
			 */
			query() {
				this.loading = true
				NProgress.start()
				queryProduct(
					this.pageSize,
					this.pageIndex,
					{
						name: this.queryKey,
						updated: this.filterUpdated,
					},
					this.createdTimeSort
				).then(({ data }) => {
					this.tableData = data._embedded
					this.loading = false
					this.pageCount = data._total_pages
					NProgress.done()
				})
			},
			/**
			 * 排序
			 */
			sortChange(sortInfo) {
				this.createdTimeSort = sortInfo.order === 'ascending' ? 1 : -1
			},
			/**
			 * 筛查。
			 */
			filterChange(filterInfo) {
				console.log(filterInfo.updated)
				this.filterUpdated = filterInfo.updated

				this.query()
			},
			/**
			 * 切换页码。
			 */
			currentChange(pageIndex) {
				this.pageIndex = pageIndex
				this.query()
			},
			/**
			 * 记录数量切换。
			 */
			sizeChange(size) {
				this.pageSize = size
				this.pageIndex = 1
				this.query()
			},
			/**
			 * 添加产品。
			 */
			add() {
				this.dialogVisible = true
				this.form = {
					name: '',
					code: '',
					tech_group_id: '',
					process_group_id: '',
					updated: 0,
					defect_level_file_id: '',
					created_time: { $date: new Date().getTime() },
					grade: 0,
					remark: '',
				}
				this.dialogTitle = '新增产品'
			},
			/**
			 * 保存产品。
			 */
			save(formName) {
				if (this.saving) {
					return
				} else {
					this.saving = true
				}

				console.log('this.form', this.form)
				this.$refs[formName].validate(valid => {
					if (valid) {
						saveProduct(this.form)
							.then(res => {
								console.log('保存产品', res)
							})
							.finally(() => {
								this.dialogVisible = false
								this.query()

								setTimeout(() => {
									this.saving = false
								}, 1000)
							})
					} else {
						this.saving = false
						console.log('error submit!!')
						return false
					}
				})
			},
			/**
			 * 编辑产品。
			 */
			handleEdit(row) {
				this.form = { ...row }
				this.dialogTitle = '修改产品名称'
				this.dialogVisible = true
			},
			/**
			 * 删除产品。
			 */
			handleDelete(row) {
				var id = row._id.$oid
				productRequest.deleteById(id).finally(() => {
					this.query()
				})
			},
			/**
			 * 弹出工艺参数组设置。
			 */
			showProcessGroupDialog(row) {
				this.currentProductId = row._id.$oid
				this.dialog.process.visible = true
			},
			/**
			 * 展示工序组。
			 */
			showProcessDetails(row) {
				this.currentProductId = row._id.$oid
				this.currentProcessGroupId = row.process_group_id
			},
			/**
			 * 关联工序。
			 */
			handleSelectGroup(group) {
				this.loading = true
				productRequest
					.modifyById(this.currentProductId, {
						process_group_id: group._id.$oid,
					})
					.finally(() => {
						this.query()
						this.dialog.process.visible = false
					})
			},
			/**
			 * 获取产品等级名称。
			 */
			getLevelName(value) {
				return ProductLevel.getLevelName(value)
			},
		},
		created() {
			//加载基础数据。
			var p1 = techGroupRequest.queryAll()
			var p2 = processGroupRequest.queryAll()

			Promise.all([p1, p2]).then(result => {
				this.techGroups = result[0]
				this.processGroups = result[1]
			})

			this.query()
		},
	}
</script>

<style></style>
